
import Vue from 'vue'
import vButton from '@/components/vButton.vue'
import vBackButton from '@/components/vBackButton.vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
@Component({ name: 'vPopup', components: { vButton, vBackButton } })
export default class indexView extends Vue {
  @Prop({
    type: String,
    default: '',
  })
  title!: string

  @Prop({
    type: Boolean,
    default: false,
  })
  isShow!: boolean

  @Prop({
    type: String,
    default: '',
  })
  text!: string
  @Prop({
    type: String,
    default: 'justify',
  })
  textDirect!: string

  @Prop({
    type: String,
    default: '取消',
  })
  cancelLabel!: string

  @Prop({
    type: String,
    default: '确定',
  })
  confirmLabel!: string

  @Prop({
    type: Number,
    default: 1,
  })
  cancelWidth!: number

  @Prop({
    type: Number,
    default: 1,
  })
  confirmWidth!: number

  @Prop({
    type: Number,
    default: 2.73,
  })
  dialogHeight!: number
  @Prop({
    type: Boolean,
    default: true,
  })
  cancelShow!: boolean

  closeOver() {
    this.$emit('closeOver')
  }
  cancel() {
    this.$emit('cancelhandleclick')
  }
  confirm() {
    this.$emit('confirmhandleclick')
  }
}
